export var ModifierKey;
(function (ModifierKey) {
    ModifierKey[ModifierKey["None"] = 0] = "None";
    ModifierKey[ModifierKey["A"] = 1] = "A";
    ModifierKey[ModifierKey["B"] = 2] = "B";
    ModifierKey[ModifierKey["C"] = 3] = "C";
    ModifierKey[ModifierKey["D"] = 4] = "D";
    ModifierKey[ModifierKey["E"] = 5] = "E";
    ModifierKey[ModifierKey["F"] = 6] = "F";
    ModifierKey[ModifierKey["G"] = 7] = "G";
    ModifierKey[ModifierKey["H"] = 8] = "H";
    ModifierKey[ModifierKey["I"] = 9] = "I";
    ModifierKey[ModifierKey["J"] = 10] = "J";
    ModifierKey[ModifierKey["K"] = 11] = "K";
    ModifierKey[ModifierKey["L"] = 12] = "L";
    ModifierKey[ModifierKey["M"] = 13] = "M";
    ModifierKey[ModifierKey["N"] = 14] = "N";
    ModifierKey[ModifierKey["O"] = 15] = "O";
    ModifierKey[ModifierKey["P"] = 16] = "P";
    ModifierKey[ModifierKey["Q"] = 17] = "Q";
    ModifierKey[ModifierKey["R"] = 18] = "R";
    ModifierKey[ModifierKey["S"] = 19] = "S";
    ModifierKey[ModifierKey["T"] = 20] = "T";
    ModifierKey[ModifierKey["U"] = 21] = "U";
    ModifierKey[ModifierKey["V"] = 22] = "V";
    ModifierKey[ModifierKey["W"] = 23] = "W";
    ModifierKey[ModifierKey["X"] = 24] = "X";
    ModifierKey[ModifierKey["Y"] = 25] = "Y";
    ModifierKey[ModifierKey["Z"] = 26] = "Z";
    ModifierKey[ModifierKey["One"] = 27] = "One";
    ModifierKey[ModifierKey["Two"] = 28] = "Two";
    ModifierKey[ModifierKey["Three"] = 29] = "Three";
    ModifierKey[ModifierKey["Four"] = 30] = "Four";
    ModifierKey[ModifierKey["Five"] = 31] = "Five";
    ModifierKey[ModifierKey["Six"] = 32] = "Six";
    ModifierKey[ModifierKey["Seven"] = 33] = "Seven";
    ModifierKey[ModifierKey["Eight"] = 34] = "Eight";
    ModifierKey[ModifierKey["Nine"] = 35] = "Nine";
    ModifierKey[ModifierKey["Zero"] = 36] = "Zero";
})(ModifierKey || (ModifierKey = {}));
;
